import { useRef, useEffect } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger); // ← Wajib ditambahkan

export default function HeroSection() {
    const heroRef = useRef(null);

    useEffect(() => {
        gsap.from(heroRef.current, {
            opacity: 0,
            y: 50,
            duration: 1.5,
            delay: 0.5,
            ease: "power3.out",
        });
    }, []);

    return (
        <section id="hero" className="hero-section" style={{ paddingTop: "80px" }}>
            <video autoPlay muted loop playsInline className="hero-video">
                <source src="/videos/av-tech.mp4" type="video/mp4" />
            </video>
            <div className="hero-overlay">
                <h1 ref={heroRef} className="hero-title">
                    Connect the Tech, Enhance the Experience
                </h1>
                <a href="#contact" className="btn btn-neon">
                    Get Started
                </a>
            </div>
        </section>
    );
}